import { FMFeeSection, FMFeeSections } from 'app/models/fm-metadata-params'

/**
 * Funding Memo parity for the portal's own fee display. The backend resolves each fee's
 * Fee Breakdown state (NOT_APPLICABLE / NOT_OPEN / CLOSED / FULL) once, and the memo, the live
 * preview and this panel all render from that same answer. Nothing here recomputes dates.
 */

export const DC_FEE_TYPE = 'Delayed Compensation'
export const COC_FEE_TYPE = 'Cost of Carry'

export const feeSectionFor = (
  feeType: string,
  sections?: FMFeeSections | null,
): FMFeeSection | undefined => {
  if (!sections) return undefined
  if (feeType === DC_FEE_TYPE) return sections.dc
  if (feeType === COC_FEE_TYPE) return sections.coc
  return undefined
}

/** A fee row is shown (even at 0.00) unless the memo states a nil for it. Unknown fees are always shown. */
export const isFeeSectionFull = (
  feeType: string,
  sections?: FMFeeSections | null,
): boolean => {
  const section = feeSectionFor(feeType, sections)
  return !section || section.state.kind === 'FULL'
}

export interface FeeSectionNote {
  feeType: string
  statement: string
}

/** The statements to show in place of the DC / CoC rows, in the memo's order (DC first). */
export const feeSectionNotes = (
  sections?: FMFeeSections | null,
): FeeSectionNote[] => {
  if (!sections) return []
  return [
    { feeType: DC_FEE_TYPE, section: sections.dc },
    { feeType: COC_FEE_TYPE, section: sections.coc },
  ]
    .filter(({ section }) => section && section.state.kind !== 'FULL' && !!section.statement)
    .map(({ feeType, section }) => ({ feeType, statement: section.statement as string }))
}
